import InputTime from "./inputTime";

export default InputTime;